import {
  useNavigate,
  type NavigateFunction,
  type NavigateOptions,
  type To,
} from 'react-router-dom';
import { useScopeTransition } from './useScopeChangeHooks';
import { useCallback } from 'react';
import type { ScopeTransition } from '@/providers/ScopeChangeProvider/types.ts';

interface NavigateWithGuardOptions {
  context?: string;
}

export function useGuardedNavigation(
  guardedNavOptions: NavigateWithGuardOptions | undefined = undefined
): NavigateFunction {
  const navigate = useNavigate();
  const { requestTransition } = useScopeTransition();

  const navigateWithGuard: NavigateFunction = useCallback(
    (to: To | number, options?: NavigateOptions) => {
      const transition: ScopeTransition = {
        id: guardedNavOptions?.context ?? 'guarded-navigation',
        run: () => {},
      };
      if (typeof to === 'number') {
        transition.run = () => navigate(to);
      } else {
        transition.run = () => navigate(to, options);
      }
      requestTransition(transition);
    },
    [guardedNavOptions?.context, navigate, requestTransition]
  );

  return navigateWithGuard;
}
